// extracted by mini-css-extract-plugin
module.exports = {"phoneModal":"PhoneModal_phoneModal__3R4_x","phoneIcon":"PhoneModal_phoneIcon__2Y1XE"};